var orionNewsResourcesData;
;(function ($) {

  //Globals
  let WP = orionNewsResourcesData,
    isFiltering = false;

  /**
   * On Mobile turn the filters into form <select> elements.
   */
  function initMobileFilters() {
    // console.log('initMobileFilters');

    // Turn filters into dropdowns on mobile only
    if (Foundation.MediaQuery.only('small')) {

      // Category Filter
      const categoryFilterListContainer = $('#category_list_container');
      const currentURL = window.location.href;
      console.log('currentURL', currentURL);
      let categoryListDropdownHTML = '<form id="category_filter_list"><label for="category">Filter by category<span class="show-for-sr">, this will take you to a new url upon selection.</span>:</label>';
      categoryListDropdownHTML += '<select id="category" name="tag">';
      categoryListDropdownHTML += '<option value="">Select Category</option>';
      categoryList.forEach(function (item) {
        let selected = '';
        if( currentURL === item.permalink ) {
          selected = ' selected';
        }
        categoryListDropdownHTML += '<option value="' + item.permalink + '"' + selected + '>' + item.name + '</option>';
      });
      categoryListDropdownHTML += '</select></form>';
      categoryFilterListContainer.empty();
      categoryFilterListContainer.html(categoryListDropdownHTML);

      // Tag Filter
      const tagFilterListForm = $('#tag_filter_list');
      let tagListDropdownHTML = '<label for="tag">Filter by subject (tags):</label>';
      tagListDropdownHTML += '<select id="tag" name="tag">';
      tagListDropdownHTML += '<option value="">Select Tag</option>';
      tagList.forEach(function (item) {
        tagListDropdownHTML += '<option value="' + item.term_id + '">' + item.name + '</option>';
      });
      tagListDropdownHTML += '</select>';
      tagFilterListForm.empty();
      tagFilterListForm.html(tagListDropdownHTML);


    }

  }

  /**
   * Show the loading spinner with the correct message
   * @param loadMoreButton
   */
  function showLoadingSpinner(loadMoreButton) {
    // console.log('showLoadingSpinner()');
    loadMoreButton.html(WP.loading_button_message.loading);
  }

  /**
   * Hide the loading spinner after ajax call
   * @param loadMoreButton
   */
  function hideLoadingSpinner(loadMoreButton) {
    // console.log('showLoadingSpinner()');
    loadMoreButton.html(WP.loading_button_message.load_more);
  }

  /**
   * Performs the REST call using the filters and pagination, and loads more posts.
   */
  function loadMorePosts(event, isTagChange) {
    // console.log('loadMorePosts');

    if (isFiltering) {
      return;
    }
    isFiltering = true;

    let $this = $(this),
      postsList = $('ul[data-posts-list]'),
      pageVal = parseInt($this.attr('data-load-more')),
      categoryTermIDVal = $this.attr('data-category-term-id'),
      tagTermIDVal = $this.attr('data-tag-term-id'),
      parameters = {};

    if (isTagChange) {
      // console.log('this is a tag change');
      $this.removeClass('no-more-message');
      postsList.empty();
    }

    if ($this.hasClass('no-more-message')) {
      isFiltering = false;
      return;
    }
    // console.log('pageVal', pageVal);

    showLoadingSpinner($this);
    // set the page parameter
    parameters.page = pageVal;
    // set the term id parameter
    if (categoryTermIDVal.length) {
      parameters.category_id = categoryTermIDVal;
    }

    if (tagTermIDVal.length) {
      parameters.tag_id = tagTermIDVal;
    }

    // The REST Call and callback built in.
    $.get(WP.endpoint_url, parameters, function (data) {
      // console.log('WP API CALL RETURN DATA:');
      // console.table(data);

      if (data.tiles_output.length) {
        // add the returned past events to the list
        postsList.append(data.tiles_output);
        // change the page for the next load more
        $this.attr('data-load-more', data.next_page);
        hideLoadingSpinner($this);
        isFiltering = false;

        // console.log('max_num_pages', data.max_num_pages);
        // If all the results have loaded show "All posts loaded message"
        if (data.max_num_pages === pageVal) {
          // $this.removeClass('button');
          $this.addClass('no-more-message');
          $this.html(WP.all_results_message);
        }


      } else {
        isFiltering = false;
        // console.log('no more past events');
        // $this.removeClass('button');
        $this.addClass('no-more-message');
        if (data.no_results) {
          $this.html(WP.no_results_message);
        } else {
          $this.html(WP.no_more_results_message);
        }
      }
    });

  }

  /**
   * Change the Mobile Category filter, triggering a page load to the new archive.
   */
  function changeMobileCategoryFilter() {
    let $this = $(this),
      categoryPermalink = $this.val();
    // console.log('changeMobileCategoryFilter', categoryPermalink);
    window.location = categoryPermalink;

  }

  /**
   * Change the Tag filter, update the load more button's data attributes and trigger a click to start the rest call.
   */
  function changeTagFilter() {
    let $this = $(this),
      tagVal = $this.val(),
      loadMoreButton = $('[data-load-more-posts]');
    // console.log('changeDesktopTagFilter', tagVal);
    loadMoreButton.attr('data-tag-term-id', tagVal);
    loadMoreButton.attr('data-load-more', 1);
    loadMoreButton.trigger('click', [true]);

  }

  function tagFilterReset(e) {
    e.preventDefault();
    let tagFilter = $('input[name="tag"]'),
      loadMoreButton = $('[data-load-more-posts]');
    tagFilter.prop('checked', false);
    loadMoreButton.attr('data-tag-term-id', 0);
    loadMoreButton.attr('data-load-more', 1);
    loadMoreButton.trigger('click', [true]);
  }


  $(document).ready(function () {
    initMobileFilters();

    $('body')
      .on('click', '[data-load-more-posts]', loadMorePosts)
      .on('change', 'input[name="tag"]', changeTagFilter)
      .on('change', '#tag', changeTagFilter)
      .on('change', '#category', changeMobileCategoryFilter)
      .on('click', '#tag_filter_reset', tagFilterReset);

  });

  $(window).on('changed.zf.mediaquery', function (event, name) {
    if (name === 'small') {
      initMobileFilters();
    }
  });

})(jQuery);

